var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .radar-cls-1 {\n        fill: #d0d6dc;\n      }\n\n      .radar-cls-1, .radar-cls-2 {\n        opacity: .5;\n      }\n\n      .radar-cls-2, .radar-cls-3 {\n        fill: #b0b7bf;\n      }\n\n      .radar-cls-4 {\n        fill: none;\n        opacity: .2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2-2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "radar-cls-4",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "bright-fill",
    className: "radar-cls-1",
    points: "12 7.45 7.67 9.47 8.36 14.24 12 21.21 18.7 15.87 18.98 8.14 12 7.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "deep-fill",
    className: "radar-cls-2",
    points: "12 4 5.52 8.26 5.28 15.91 11.97 16.19 17.49 15.16 18.1 8.65 12 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M12,1.58l9.03,5.21v10.42l-9.03,5.21-9.03-5.21V6.79L12,1.58M12,1L2.47,6.5v11l9.53,5.5,9.53-5.5V6.5L12,1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M12,2.25c-.14,0-.25-.11-.25-.25v-.5c0-.14.11-.25.25-.25s.25.11.25.25v.5c0,.14-.11.25-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M12,20.2c-.14,0-.25-.11-.25-.25v-1c0-.14.11-.25.25-.25s.25.11.25.25v1c0,.14-.11.25-.25.25ZM12,17.21c-.14,0-.25-.11-.25-.25v-1c0-.14.11-.25.25-.25s.25.11.25.25v1c0,.14-.11.25-.25.25ZM12,14.21c-.14,0-.25-.11-.25-.25v-1c0-.14.11-.25.25-.25s.25.11.25.25v1c0,.14-.11.25-.25.25ZM12,11.22c-.14,0-.25-.11-.25-.25v-1c0-.14.11-.25.25-.25s.25.11.25.25v1c0,.14-.11.25-.25.25ZM12,8.23c-.14,0-.25-.11-.25-.25v-1c0-.14.11-.25.25-.25s.25.11.25.25v1c0,.14-.11.25-.25.25ZM12,5.24c-.14,0-.25-.11-.25-.25v-1c0-.14.11-.25.25-.25s.25.11.25.25v1c0,.14-.11.25-.25.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M12,22.69c-.14,0-.25-.11-.25-.25v-.5c0-.14.11-.25.25-.25s.25.11.25.25v.5c0,.14-.11.25-.25.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M3.26,7.2s-.09-.01-.12-.03l-.43-.25c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.43.25c.12.07.16.22.09.34-.05.08-.13.12-.22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M18.86,16.21s-.09-.01-.12-.03l-.87-.5c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.87.5c.12.07.16.22.09.34-.05.08-.13.12-.22.12ZM16.26,14.71s-.09-.01-.12-.03l-.87-.5c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.87.5c.12.07.16.22.09.34-.05.08-.13.12-.22.12ZM13.66,13.21s-.09-.01-.12-.03l-.87-.5c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.87.5c.12.07.16.22.09.34-.05.08-.13.12-.22.12ZM11.06,11.71s-.09-.01-.12-.03l-.87-.5c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.87.5c.12.07.16.22.09.34-.05.08-.13.12-.22.12ZM8.46,10.21s-.09-.01-.12-.03l-.87-.5c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.87.5c.12.07.16.22.09.34-.05.08-.13.12-.22.12ZM5.86,8.71s-.09-.01-.12-.03l-.87-.5c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.87.5c.12.07.16.22.09.34-.05.08-.13.12-.22.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M21.03,17.46s-.09-.01-.12-.03l-.43-.25c-.12-.07-.16-.22-.09-.34.07-.12.22-.16.34-.09l.43.25c.12.07.16.22.09.34-.05.08-.13.12-.22.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M20.62,7.47c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.44-.25c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.44.25s-.08.03-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M5.14,16.24c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.86-.49c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.86.49s-.08.03-.12.03ZM7.72,14.78c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.86-.49c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.86.49s-.08.03-.12.03ZM10.3,13.32c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.86-.49c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.86.49s-.08.03-.12.03ZM12.88,11.85c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.86-.49c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.86.49s-.08.03-.12.03ZM15.46,10.39c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.86-.49c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.86.49s-.08.03-.12.03ZM18.04,8.93c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.86-.49c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.86.49s-.08.03-.12.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill-2",
    className: "radar-cls-3",
    d: "M2.98,17.46c-.09,0-.17-.05-.22-.13-.07-.12-.03-.27.09-.34l.44-.25c.12-.07.27-.03.34.09.07.12.03.27-.09.34l-.44.25s-.08.03-.12.03Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRader);
export default __webpack_public_path__ + "static/media/rader.c03199288127a964c52d7ca5539314cf.svg";
export { ForwardRef as ReactComponent };